/**
 * @file font-role-summary.ts
 * @description Сводка роли шрифта у свёрнутой группы во вкладке «Оформление
 * → Шрифты» (phase19.16, SB122; uiux-settings-groups §5 шаг 3): имя
 * шрифта («Montserrat · 700» у заголовков — с начертанием), у невыбранного
 * акцента — чем он сейчас стоит на сайте; «!» — свой шрифт без русских букв.
 */

import { FONT_ROLES, effectiveFontKey, isShopFontEntry, isShopFontKey, type FontRole, type SiteFontRegistry, type SiteTheme } from "@chaiberi/shared";

export interface FontRoleSummary {
  summary: string;
  /** Свой шрифт без кириллицы — предупреждение в заголовке группы. */
  warning: boolean;
}

/** Название шрифта по ключу: из реестра магазина; свой без записи — «свой шрифт». */
export function fontFamilyName(key: string, registry: SiteFontRegistry): string {
  return registry.find(key)?.family ?? (isShopFontKey(key) ? "свой шрифт" : key);
}

/**
 * @param weight начертание заголовков (уже сверенное с весами шрифта); только для `heading`
 */
export function fontRoleSummary(role: FontRole, theme: SiteTheme, registry: SiteFontRegistry, weight?: number): FontRoleSummary {
  const key = theme.fonts[role];
  if (key === null) {
    const effective = effectiveFontKey(role, theme);
    return { summary: `не выбран — шрифт ${FONT_ROLES[effective.role].genitive}`, warning: false };
  }
  const entry = registry.find(key);
  const name = fontFamilyName(key, registry);
  const warning = entry !== undefined && isShopFontEntry(entry) && !entry.hasCyrillic;
  return { summary: role === "heading" && weight !== undefined ? `${name} · ${weight}` : name, warning };
}
